import React from 'react';
import { useClassnames } from '@wb-tech/ui-react';
import { Modal, Text, Title } from '@wb-tech/ui-react/v2';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useSelector } from '#core/store';

import { getMediaQuery } from '#component/media-query/slice';

import style from './index.module.pcss';

interface IProps {
    isOpen: boolean,
    onClose: () => void
}

export const WhatIsBalanceModal = (props: IProps) => {
    const cn = useClassnames(style);
    const { t } = useTranslation();
    const { isMobile } = useSelector((state) => state[getMediaQuery.name]);

    return (
        <Modal
            isOpen={props.isOpen}
            widthPreset={isMobile ? 'm' : 'l'}
            onClose={props.onClose}
            header={(
                <Title
                    tagName="h3"
                    children={t('components.what-is-balance-modal.title')}
                />
            )}
            className={{
                'modal__body'    : cn('what-is-balance-modal__body'),
                'modal__children': cn('what-is-balance-modal__children')
            }}
        >
            <Trans
                parent={Text}
                className={cn('what-is-balance-modal__content')}
                // @TODO: Разобраться с типами при использование object
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                i18nKey="components.what-is-balance-modal.text"
                components={{
                    'link-faq': <Link
                        to="/campaigns/help/faq"
                    />
                }}
                tOptions={{
                    joinArrays: '\n'
                }}
            />
        </Modal>
    );
};
